import React, { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import '../styles/ItemForm.css';
import { crearProveedor, actualizarProveedor, Proveedor } from '../services/proveedores';

interface ProveedorFormProps {
    onClose: () => void;
    onSuccess: (message: string, proveedor?: Proveedor) => void;
    itemData?: Proveedor;
}

const ProveedorForm: React.FC<ProveedorFormProps> = ({ onClose, onSuccess, itemData }) => {
    const [formData, setFormData] = useState({
        nombre: '',
        contacto: '',
        telefono: '',
        direccion: '',
        email: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (itemData) {
            setFormData({
                nombre: itemData.nombre || '',
                contacto: itemData.contacto || '',
                telefono: itemData.telefono || '',
                direccion: itemData.direccion || '',
                email: itemData.email || ''
            });
        }
    }, [itemData]);

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setError(null);
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        
        if (!formData.nombre.trim()) {
            setError('El nombre del proveedor es obligatorio');
            return;
        }

        setLoading(true);
        try {
            if (itemData?.id) {
                const updated = await actualizarProveedor(itemData.id, formData as Partial<Proveedor>);
                onSuccess(`¡Proveedor actualizado correctamente!`, updated);
            } else {
                const created = await crearProveedor(formData as Partial<Proveedor>);
                onSuccess(`¡Proveedor creado correctamente!`, created);
            }
        } catch (error: any) {
            console.error(`Error al ${itemData?.id ? 'actualizar' : 'crear'} proveedor:`, error);
            setError(error.response?.data?.message || 'Error al guardar el proveedor');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form className="item-form" onSubmit={handleSubmit}>
            <h3 className="form-title">{itemData?.id ? `Editar Proveedor` : `Nuevo Proveedor`}</h3>
            {error && <div className="error-message" style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}

            <label>
                Nombre del Proveedor: <span style={{ color: 'red' }}>*</span>
                <input
                    type="text"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    placeholder="Razón Social o Nombre"
                    required
                />
            </label>
            <label>
                Persona de Contacto:
                <input
                    type="text"
                    name="contacto"
                    value={formData.contacto}
                    onChange={handleChange}
                    placeholder="Nombre del encargado o vendedor"
                />
            </label>
            <label>
                Teléfono:
                <input
                    type="text"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    placeholder="Número de celular/fijo"
                />
            </label>
            <label>
                Correo Electrónico:
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email comercial"
                />
            </label>
            <label>
                Dirección / Sucursal:
                <textarea
                    name="direccion"
                    value={formData.direccion}
                    onChange={handleChange}
                    placeholder="Dirección física completa"
                />
            </label>
            
            <div className="button-group" style={{ marginTop: '20px' }}>
                <button type="submit" className="button primary" disabled={loading}>
                    {loading ? 'Guardando...' : (itemData?.id ? 'Actualizar' : 'Crear Proveedor')}
                </button>
                <button
                    type="button"
                    className="button secondary"
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancelar
                </button>
            </div>
        </form>
    );
};

export default ProveedorForm;
